export default __webpack_public_path__ + "static/about_mission_vision-ea9daad617c91d9131fca512c7cfca53.jpg";